import { forwardRef, useCallback, type InputHTMLAttributes } from 'react';
import { isValidVKN } from '@custel/turkish';
import { Input } from '../Field';
import { cn } from '../../../lib/cn';

export interface VKNInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
  value: string;
  onChange: (value: string) => void;
  validate?: boolean;
}

/**
 * VKN (Vergi Kimlik Numarası) — 10 hane, GİB algoritması.
 */
export const VKNInput = forwardRef<HTMLInputElement, VKNInputProps>(
  ({ value, onChange, validate = true, className, ...rest }, ref) => {
    const valid = !validate || value.length < 10 || isValidVKN(value);

    const handle = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const raw = e.target.value.replace(/\D+/g, '').slice(0, 10);
        onChange(raw);
      },
      [onChange],
    );

    return (
      <Input
        ref={ref}
        value={value}
        onChange={handle}
        placeholder="1234567890"
        inputMode="numeric"
        autoComplete="off"
        spellCheck={false}
        maxLength={10}
        aria-invalid={!valid}
        className={cn('font-mono tracking-widest', className)}
        {...rest}
      />
    );
  },
);
VKNInput.displayName = 'VKNInput';
